import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-435573fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "department-installation-chart-wrap" }
const _hoisted_2 = { class: "chart-container" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { getAssignPieOption } from '@/utils/echarts-option/pie'
import { getChartPieMixedPalette } from '@/utils/chart-theme-colors'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import Card from '@/views/dashboard/_components/card/card.vue'
import PieCenter from '@/views/dashboard/_components/echarts/pie-center.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'

interface ChartDataItem {
  name: string
  value: number
  /** 与终端列表 group_id 一致，来自 /softmgr/soft-group-type-stat */
  group_id?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'department-installation-chart',
  props: {
  /** 部门软件安装数量数据 */
  data: {
    type: Array as () => ChartDataItem[],
    default: () => []
  },
},
  emits: ["sliceClick"],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n()

const emit = __emit

const props = __props

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)

const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

const colors = computed(() => getChartPieMixedPalette())

/** 图表数据 */
const chartData = computed(() => {
  if (!props.data || props.data.length === 0) return []
  const palette = colors.value
  return props.data.map((item, index) => ({
    name: item.name,
    value: item.value,
    group_id: item.group_id,
    color: palette[index % palette.length]
  }))
})

const totalCount = computed(() =>
  chartData.value.reduce((sum, item) => sum + item.value, 0)
)

const hasData = computed(() => totalCount.value > 0)

function getChartData () {
  return chartData.value.map(item => ({
    value: item.value,
    name: item.name,
    group_id: item.group_id,
    itemStyle: {
      color: item.color,
    },
  }))
}

function bindChartClick () {
  chartInstance?.off('click')
  chartInstance?.on('click', (params: unknown) => {
    const p = params as { componentType?: string; data?: { name?: string; value?: number; realValue?: number; group_id?: number } }
    if (p.componentType !== 'series' || !p.data) return
    const { name, value, realValue, group_id: dataGroupId } = p.data
    if (name == null) return
    // ECharts 合并 option 后 data 上可能只剩 name/value/realValue，用名称回查 group_id
    const fromChart = chartData.value.find((d) => d.name === name)
    const group_id = dataGroupId ?? fromChart?.group_id
    emit('sliceClick', {
      name,
      value: Number(realValue ?? value ?? 0),
      group_id,
    })
  })
}

function createChart () {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
  bindChartClick()
}

function getChartOption () {
  void locale.value
  const option = {
    series: [{
      name: t('softwareManage.chartSeriesName'),
      data: getChartData(),
      cursor: 'pointer',
    }],
  }

  return getAssignPieOption(option, { unit: t('softwareManage.unitPiece') })
}

function renderChart () {
  if (!chartInstance) return
  chartInstance.setOption(getChartOption())
  bindChartClick()
}

function initChart () {
  chartInstance?.dispose()
  createChart()
  renderChart()
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance?.resize()
})

watch(locale, () => {
  if (chartInstance) renderChart()
})

watch(() => props.data, () => {
  if (!hasData.value) {
    chartInstance?.dispose()
    chartInstance = null
    return
  }
  if (!chartInstance) {
    nextTick(() => {
      setTimeout(() => initChart(), 100)
    })
  } else {
    renderChart()
  }
}, { deep: true, immediate: true })

useEchartsThemeSync(() => {
  if (chartInstance && hasData.value) renderChart()
})

onMounted(() => {
  if (hasData.value) {
    setTimeout(() => initChart(), 100)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance?.dispose()
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: _ctx.$t('softwareManage.departmentInstallTitle'),
    style: {"height":"100%"}
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop10')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            ref_key: "chartRef",
            ref: chartRef,
            class: "chart"
          }, null, 512),
          _createVNode(PieCenter, {
            title: _ctx.$t('softwareManage.totalCount'),
            value: totalCount.value,
            unit: _ctx.$t('softwareManage.unitPiece')
          }, null, 8, ["title", "value", "unit"])
        ], 512), [
          [_vShow, hasData.value]
        ]),
        _withDirectives(_createVNode(EmptyData, {
          height: "100%",
          "bg-color": "transparent"
        }, null, 512), [
          [_vShow, !hasData.value]
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})